/**
 * Auto-adds a variant when the URL contains ?auto-add-{variantId}
 * e.g. ?auto-add-40792423366817
 * Adds the line with GWP properties for Discount Kit targeting.
 */
(function () {
  const configEl = document.getElementById('auto-add-gwp-config');
  if (!configEl) return;

  let config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (error) {
    console.error('[auto-add-gwp] Invalid config', error);
    return;
  }

  const allowedVariantIds = (config.allowedVariantIds || []).map(Number).filter(Boolean);
  const quantity = Number(config.quantity) || 1;
  const properties = config.properties || { _gwp: 'true' };

  function getVariantIdFromUrl() {
    const params = new URLSearchParams(window.location.search);

    for (const key of params.keys()) {
      const match = key.match(/^auto-add-(\d+)$/);
      if (match) return Number(match[1]);
    }

    for (const value of params.values()) {
      const match = String(value).match(/^auto-add-(\d+)$/);
      if (match) return Number(match[1]);
    }

    const searchMatch = window.location.search.match(/(?:^\?|&)auto-add-(\d+)(?:=|&|$)/);
    return searchMatch ? Number(searchMatch[1]) : null;
  }

  function cleanUrl(variantId) {
    const url = new URL(window.location.href);
    const paramKey = `auto-add-${variantId}`;
    if (!url.search.includes(paramKey)) return;

    const params = new URLSearchParams(url.search);
    params.delete(paramKey);
    for (const [key, value] of [...params.entries()]) {
      if (value === paramKey || key === '') params.delete(key);
    }

    const next = `${url.pathname}${params.toString() ? `?${params}` : ''}${url.hash}`;
    window.history.replaceState({}, '', next);
  }

  function alreadyInCart(cart, variantId) {
    return (cart.items || []).some((item) => {
      if (Number(item.id) !== variantId && Number(item.variant_id) !== variantId) return false;
      return item.properties && item.properties._gwp === 'true';
    });
  }

  async function refreshCart() {
    try {
      const sections = 'mini-cart,cart-icon-bubble,mobile-cart-icon-bubble';
      const response = await fetch(`${window.location.pathname}?sections=${sections}`);
      const sectionsData = await response.json();

      if (sectionsData['mini-cart']) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(sectionsData['mini-cart'], 'text/html');
        const newCartItems = doc.querySelector('#main-cart-items');
        const currentCartItems = document.querySelector('#main-cart-items');
        if (newCartItems && currentCartItems) {
          currentCartItems.innerHTML = newCartItems.innerHTML;
        }

        const newFooter = doc.querySelector('#main-cart-footer');
        const currentFooter = document.querySelector('#main-cart-footer');
        if (newFooter && currentFooter) {
          currentFooter.innerHTML = newFooter.innerHTML;
        }
      }

      ['cart-icon-bubble', 'mobile-cart-icon-bubble'].forEach((sectionId) => {
        if (!sectionsData[sectionId]) return;
        const el = document.getElementById(`shopify-section-${sectionId}`) || document.getElementById(sectionId);
        if (el) el.innerHTML = sectionsData[sectionId];
      });
    } catch (error) {
      console.warn('[auto-add-gwp] Cart UI refresh failed', error);
    }

    document.dispatchEvent(new CustomEvent('cart:updated'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  async function run() {
    const variantId = getVariantIdFromUrl();
    if (!variantId) return;

    if (allowedVariantIds.length && !allowedVariantIds.includes(variantId)) {
      console.warn('[auto-add-gwp] Variant not allowlisted:', variantId);
      return;
    }

    const storageKey = `auto-add-gwp:${variantId}`;
    if (sessionStorage.getItem(storageKey) === '1') {
      cleanUrl(variantId);
      return;
    }

    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();

      if (alreadyInCart(cart, variantId)) {
        sessionStorage.setItem(storageKey, '1');
        cleanUrl(variantId);
        return;
      }

      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity,
              properties,
            },
          ],
        }),
      });

      const data = await addResponse.json();
      if (!addResponse.ok) {
        throw new Error(data.description || data.message || 'Failed to add GWP item');
      }

      sessionStorage.setItem(storageKey, '1');
      cleanUrl(variantId);
      await refreshCart();
      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          detail: { product: data, gwpAutoAdd: true },
        })
      );
    } catch (error) {
      console.error('[auto-add-gwp]', error);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
